import React, { Component } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { getDeviceAndWidth } from 'src/Utils';
import './styles.scss';

export default class HeaderSkeletonLoader extends Component {
  render() {
    const device = getDeviceAndWidth().device;
    return (
      <div className="header-skeleton-wrapper">
        <SkeletonTheme color="#848484" highlightColor="#373737">
          <div className="heading-skeleton">
            <Skeleton width={`${device === 'desktop'? "50%" : "80%"}`} height={"100%"} />
          </div>
          <div className="mt-5">
            <Skeleton width={`${device === 'desktop'? "20%" : "60%"}`} height={10} />
          </div>
          <div className="mt-20">
            <Skeleton width={`${device === 'desktop'? "30%" : "60%"}`} height={30} />
          </div>
        </SkeletonTheme>
      </div>
    )
  }
}
